import { setupWidgetButtons, cleanupWidgetButtons, destroyWidgets } from './common/widgetManager';
import './chatkit_v2.css';

export default class ChatKitV2 {
  init() {
    if (document.getElementById('chatkit-v2-widget-container')) {
      setupWidgetButtons();
    }
  }
}

document.addEventListener('turbo:before-cache', () => {
  destroyWidgets();
  cleanupWidgetButtons();
});
